import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { InitialData } from 'app/app.types';
import { NavigationService } from './core/auth/navigation.service';
import { MessagesService } from './core/auth/tmp/messages.service';
import { UserService } from './core/auth/tmp/user2.service';
import { AuthService } from './core/auth/auth.service';
import { AuthUtils } from './core/auth/auth.utils';



@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        private _messagesService: MessagesService,
        private _userService: UserService,
        private _authService: AuthService
        )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
     resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>
    {

        // Fork join multiple API endpoint calls to wait all of them to finish
        const us = AuthUtils.decodeToken( this._authService.accessToken );
        return    forkJoin([
                this._messagesService.messages(),
                this._navigationService.registerHandlers(),
                this._userService.user(us['user_id'], 'ROLE_ADMIN')
            ]).pipe(
                map(([messages, navigation,  user ]) => (
                    {
                        messages,
                        navigation: this._navigationService.registerHandlersFijo( user['rol'] ),
                        user
                    })
                ),
            );
    }



    searchInfor(): Promise<InitialData> {

        return new Promise(( resolve, reject ) => {

            const us = AuthUtils.decodeToken( this._authService.accessToken );
            forkJoin([
                this._messagesService.messages(),
                this._navigationService.registerHandlers(),
                this._userService.user(us['user_id'], 'ROLE_ADMIN')
            ]).pipe(
                map(([messages, navigation, user ]) => (
                    {
                        messages,
                        navigation: {
                            compact   : navigation.compact,
                            default   : navigation.default,
                            futuristic: navigation.futuristic,
                            horizontal: navigation.horizontal
                        },
                        user
                    })
                )
            ).subscribe( res => { resolve( res ); }, err => reject(err));


        });


    }
}
